import styled, { css } from "styled-components";

interface StyledStatsTabProps {
  $selected: boolean;
}

export const StyledStatsTab = styled.button<StyledStatsTabProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 0 8px 10px;
  border: 0;
  border-bottom: 3px solid var(--Color-4, #7e8aad33);
  border-image: none;
  background: transparent;
  cursor: pointer;
  font-family: "Noto Sans Hebrew", sans-serif;
  text-align: center;
  position: relative;
  transition:
    color 0.2s ease,
    border-color 0.2s ease;

  &:not(:first-child)::before {
    content: "";
    position: absolute;
    inset-inline-start: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 32px;
    border-inline-start: 0.5px solid var(--Color-4, #7e8aad33);
  }

  > span:nth-of-type(1) {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: -0.33px;
    text-align: center;
    color: #7e8aad;
    line-height: 1.2;
    transition: color 0.2s ease;
  }

  > span:nth-of-type(2) {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: -0.22px;
    text-align: center;
    color: #7e8aad;
    line-height: 1.3;
    transition: color 0.2s ease;
  }

  ${(p) =>
    p.$selected &&
    css`
      border-bottom: 3px solid transparent;
      border-image-source: linear-gradient(
        269.87deg,
        #004ef7 -1.82%,
        #00eab2 97.28%
      );
      border-image-slice: 1;
      border-image-width: 0 0 3px 0;

      > span:nth-of-type(1) {
        font-weight: 900;
        color: #122243;
      }

      > span:nth-of-type(2) {
        color: #122243;
      }
    `}
`;
